import { ApplicationConfig } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { theme } from '@itmc/angular-primeng-tudo-theme/dist/theme';
import { de } from "primelocale/js/de.js";

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      ripple: true,
      translation: de,
      inputStyle: 'outlined',
      theme: {
        preset: theme
      }
    })
  ]
};
